import { SET_CLIENT_STORIES } from "../actions/action-types.js";

export default function clientStoriesClient(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_STORIES:
            return (state = payload)
        default:
            return state
    }
}